export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/orders', { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/order/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/order/' + data.id, data.body, { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/order', data.body, { params: data.filters || {} })
  }
})
